<template>
  <div class="myinfo-account-box">
    <div class="profile-title">Account information</div>
    <div class="myinfo-account-cont">
      <div class="myinfo-account-left">
        <div class="profile-item">
          <div class="profile-item-title">Email</div>
          <div class="profile-item-content">
            <el-input
              placeholder="Email"
              v-model="userInfo.email"
              disabled
            ></el-input>
          </div>
        </div>

        <el-form ref="accountInfo" :model="accountInfo" :rules="rules">
          <el-form-item label="Original Password" prop="oldPassword">
            <el-input
              type="password"
              placeholder="Original Password"
              v-model="accountInfo.oldPassword"
            ></el-input>
          </el-form-item>

          <el-form-item label="New Password" prop="newPassword">
            <el-input
              type="password"
              placeholder="New Password"
              v-model="accountInfo.newPassword"
            ></el-input>
          </el-form-item>

          <el-form-item label="Confirm Password" prop="repeatPassword">
            <el-input
              type="password"
              ref="repeatPassword"
              placeholder="Confirm Password"
              v-model="accountInfo.repeatPassword"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="profile-item" style="text-align: right">
          <el-button
            @click.native="handleChangePassword"
            :loading="changePasswordLoading"
            >Save</el-button
          >
        </div>
      </div>
      <div class="myinfo-account-right">
        <div class="card pay">
          <div class="item-title">Method of Payment</div>
          <div class="pay-method">
            <img src="@/assets/icon/paypal.svg" />
            <i
              v-if="!hasPaypal"
              class="el-icon-circle-plus-outline"
              @click="addPaypal"
            ></i>
            <i v-if="hasPaypal" class="el-icon-edit" @click="editPaypal"></i>
          </div>
          <el-select
            class="item-input_48 margintop24"
            v-if="opPaypal"
            v-model="paymentForm.recipient_type"
            placeholder="Account Type"
          >
            <el-option label="EMAIL" value="EMAIL"></el-option>
            <el-option label="PHONE" value="PHONE"></el-option>
          </el-select>
          <div
            v-if="hasPaypal && !opPaypal"
            class="item-input_48 margintop24 pay-no"
            style="text-align: left"
          >
            <span>No: {{ paymentForm.payNO }}</span>
          </div>
          <el-input
            class="item-input_118 margintop24 pay-no"
            v-if="opPaypal"
            v-model="paymentForm.payNO"
            type="textarea"
            placeholder="Paypal account"
            :row="6"
          >
          </el-input>
          <div v-if="opPaypal" style="text-align: right">
            <el-button
              class="my-button success-button margintop24"
              @click="handleConfirmPay"
              >Confirm</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { format } from "@/utils/comm";
import Cookies from "js-cookie";
import { MD5, scopeDomain } from "@/utils/comm";
export default {
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
    }),
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("Confirm password."));
      } else if (value !== this.accountInfo.newPassword) {
        callback(new Error("Passwords does not match."));
      } else {
        callback();
      }
    };
    return {
      queryStr: "",
      accountRecordlist: [],
      format: format,
      accountInfo: {
        oldPassword: "",
        newPassword: "",
        repeatPassword: "",
      },
      changePasswordVisible: false,
      rules: {
        oldPassword: [
          {
            required: true,
            message: "请输入原密码",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
        ],
        repeatPassword: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
      changePasswordLoading: false,
      opPaypal: "", //add或者update
      paymentForm: {
        payNO: "",
        recipient_type: "",
        id: "",
      },
      hasPaypal: false, //add或者update
    };
  },
  mounted() {
    this.accountInfo.passwrod = this.userInfo.passwrod;
    this.getAccoutRecord();
    this.$store.dispatch("REFRESH_USER_INFO");
    this.getPaypal();
  },
  methods: {
    getAccoutRecord() {
      this.$api.accountApi.getAccoutRecord().then((res) => {
        if (res.status === "0") {
          this.accountRecordlist = res.data.rows;
          // if(this.accountRecordlist.length<5){
          //     this.accountRecordlist.length = 5;
          // }
        }
      });
    },
    addPaypal() {
      this.opPaypal = this.opPaypal === "add" ? "" : "add";
    },
    editPaypal() {
      this.opPaypal = this.opPaypal === "update" ? "" : "update";
    },
    //获取支付账户
    getPaypal() {
      this.$api.comApi.getBankList().then((res) => {
        if (res.status === "0") {
          this.opPaypal = "";
          if (res.data.rows.length > 0) {
            this.hasPaypal = true;
            this.paymentForm.payNO = res.data.rows[0].payNO || "";
            this.paymentForm.id = res.data.rows[0].id || "";
            this.paymentForm.recipient_type =
              res.data.rows[0].recipient_type || "";
          }
        }
      });
    },
    handleConfirmPay() {
      let params = { ...this.paymentForm };
      if (!params.recipient_type) {
        this.$message.warning("Please select your account type!");
        return;
      }
      if (!params.payNO) {
        this.$message.warning("Please fill in your Paypal account!");
        return;
      }
      if (this.opPaypal === "add") {
        delete params.id;
        this.$api.comApi.addBank(params).then((res) => {
          if (res.status === "0") {
            this.$message.success(res.message);
            this.getPaypal();
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      }
      if (this.opPaypal === "update") {
        this.$api.comApi.updateBank(params).then((res) => {
          if (res.status === "0") {
            this.$message.success(res.message);
            this.getPaypal();
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      }
    },
    handleChangePassword() {
      this.$refs.accountInfo.validate((valid) => {
        if (!valid) {
          return;
        }
        this.changePasswordLoading = true;
        let params = { ...this.accountInfo };
        //todo 调试
        delete params.repeatPassword;
        params.oldPassword = MD5(params.oldPassword);
        params.newPassword = MD5(params.newPassword);
        this.$api.userApi.updatePassword(params).then((res) => {
          if (res.status === "0") {
            this.$store.commit("clearUserInfo");
            this.$message.success("SUCCESS!");
            Cookies.remove(scopeDomain.name, { domain: scopeDomain.path });

            this.$store.commit("menuRouteLoaded", false);
            this.$store.commit("SET_LOGIN_DIALOG", true);
            this.$router.push({ path: "/" });
          } else {
            this.$message.error(`ERROR! Reason : ${res.message}`);
          }

          this.changePasswordLoading = false;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.myinfo-account-box {
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;

  .profile-title {
    height: 25px;
    font-size: 18px;
    font-weight: normal;
    color: #181d2c;
    line-height: 25px;
  }
  .myinfo-account-cont {
    display: flex;
    flex-direction: row;
    .myinfo-account-left {
      flex: 1;
      box-sizing: border-box;
    }
    .myinfo-account-right {
      padding-left: 50px;
      box-sizing: border-box;
      flex: 1;
      .card {
        padding: 32px;
        background: #fff;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        box-sizing: border-box;
        .item-title {
          font-size: 14px;
          font-weight: 600;
          color: #201002;
          line-height: 20px;
          margin-bottom: 32px;
        }
        .pay-no {
          word-break: break-all;
          line-height: 24px;
          font-weight: 500;
        }
        .pay-method {
          width: 100%;
          box-sizing: border-box;
          padding: 8px 16px;
          background: rgba(32, 16, 2, 0.04);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;

          img {
            width: auto;
            height: 40px;
          }
          // i {
          //   float: right;
          // }
          .el-input {
            /deep/.el-input-group__prepend {
              width: 52px;
              background: #fff;
            }
          }
        }
        .margintop24 {
          margin-top: 24px;
        }
        /deep/ .el-textarea__inner {
          min-height: 120px !important;
          border: 1px solid rgba(32, 16, 2, 0.32) !important;
          font-family: PingFangSC-Semibold, PingFang SC;
        }
        .item-input_48 {
          width: 100%;
          height: 48px;
          /deep/.el-input__inner {
            height: 48px;
            line-height: 48px;
          }
        }
      }
    }
  }
  .profile-item {
    margin-top: 24px;
    .profile-item-title {
      height: 20px;
      font-size: 15px;
      font-weight: normal;
      color: #181d2c;
      line-height: 20px;
    }
    .profile-item-content {
      margin-top: 8px;
      .el-textarea {
        font-size: 15px;
        color: #181d2c;
      }
    }
  }
  /deep/.el-form-item__label {
    height: 20px;
    font-size: 15px;
    font-weight: normal;
    color: #181d2c;
    line-height: 20px;
    margin-bottom: 8px;
  }
  .el-form {
    margin-top: 20px;
  }
  .el-button {
    height: 48px;
    background: #f48c06;
    color: #fff;
    border: none;
  }
}
</style>